import React from 'react';

export default function ImplBlock6Roles() {
  return (
    <section className="py-24 md:py-24 px-6 md:px-16 bg-paper border-t border-line">
      <div className="max-w-[1280px] mx-auto">
        
        <div className="text-center mb-16 max-w-4xl mx-auto">
          <h2 className="text-[24px] md:text-[32px] lg:text-[48px] font-bold text-ink mb-6 tracking-tight leading-[1.2]">
            BAC coordina la operación. La clínica permanece en la red.
          </h2>
          <div className="inline-block bg-surface border-l-2 border-brand px-6 py-4 text-left">
            <span className="text-[16px] md:text-[16px] font-semibold text-ink">
              BAC no transforma una necesidad operacional en una decisión clínica.
            </span>
          </div>
        </div>

        <div className="flex flex-col md:flex-row gap-8 lg:gap-12 mb-16">
          
          {/* Operational Domain */}
          <div className="flex-1 flex flex-col gap-6">
            <div className="text-[14px] font-extrabold text-brand tracking-widest uppercase mb-2 border-b border-line pb-2">
              DOMINIO OPERACIONAL
            </div>
            
            <div className="bg-surface border border-line p-8 rounded-xl">
              <div className="text-[16px] font-extrabold text-ink tracking-widest uppercase mb-3">
                SYSTEM
              </div>
              <div className="text-[16px] text-ink-soft">
                Automatiza acciones determinísticas y autorizadas.
              </div>
            </div>

            <div className="bg-surface border border-line p-8 rounded-xl">
              <div className="text-[16px] font-extrabold text-ink tracking-widest uppercase mb-3">
                BAC OPERATOR
              </div>
              <div className="text-[16px] text-ink-soft">
                Gestiona casos accionables, coordinación, rescates y excepciones.
              </div>
            </div>
          </div>

          {/* Clinical Domain */}
          <div className="flex-1 flex flex-col gap-6">
            <div className="text-[14px] font-extrabold text-ink tracking-widest uppercase mb-2 border-b border-line pb-2">
              DOMINIO ASISTENCIAL
            </div>
            
            <div className="bg-surface border border-line p-8 rounded-xl">
              <div className="text-[16px] font-extrabold text-ink tracking-widest uppercase mb-3">
                TENS / EQUIPO TÉCNICO
              </div>
              <div className="text-[16px] text-ink-soft">
                Atiende a la persona y registra prestación / mediciones.
              </div>
            </div>

            <div className="bg-surface border border-line p-8 rounded-xl">
              <div className="text-[16px] font-extrabold text-ink tracking-widest uppercase mb-3">
                CLINICIAN
              </div>
              <div className="text-[16px] text-ink-soft">
                Diagnostica, evalúa, modifica tratamiento, define plan y toma decisiones clínicas.
              </div>
            </div>
          </div>

        </div>

        {/* AI Note */}
        <div className="bg-surface border border-line p-8 md:p-10 rounded-xl flex flex-col md:flex-row gap-8 lg:gap-16">
          <div className="md:w-1/4">
            <div className="text-[14px] font-extrabold text-ink tracking-widest uppercase">
              ROL DE IA (ASISTENTE)
            </div>
          </div>
          <div className="md:w-3/4 flex flex-col sm:flex-row gap-8">
            <div className="flex-1">
              <div className="text-[12px] font-extrabold text-brand tracking-widest uppercase mb-3">PUEDE:</div>
              <p className="text-[16px] text-ink-soft">
                interpretar · resumir · clasificar intención · sugerir acciones permitidas.
              </p>
            </div>
            <div className="flex-1">
              <div className="text-[12px] font-extrabold text-slate-600 tracking-widest uppercase mb-3">NO PUEDE:</div>
              <p className="text-[16px] text-ink-soft">
                diagnosticar · prescribir · inventar reglas · sustituir al profesional.
              </p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
